import { render, staticRenderFns } from "./administrative_function.vue?vue&type=template&id=033b13ba"
import script from "./administrative_function.vue?vue&type=script&lang=js"
export * from "./administrative_function.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports